// takes the DR settings API response and returns an array of deal types supported by the dealer
const getDealerSupportedDealTypes = (settings, type) => {
  const {
    hasLeasing
  } = settings?.products || {};
  const hasCashOffer = settings?.products[`has${type}CashOffer`];
  return ['finance', hasLeasing && type === 'New' && 'lease', hasCashOffer && 'cash'].filter(Boolean); // removes any false or undefined values from the array
};
export { getDealerSupportedDealTypes as default };
